import angular from 'angular';
import RelevantTerms from './relevant-terms.filter';
import FirstLastName from './first-last-name.filter';
import MomentFormat from './moment-format';
import PhoneFormat from './phone-format';

let filtersModule = angular.module('app.filters', [])

.filter('relevantTerms', RelevantTerms)
.filter('firstLastName', FirstLastName)
.filter('momentFormat', MomentFormat)
.filter('phoneFormat', PhoneFormat)

.name;

export default filtersModule;



// WEBPACK FOOTER //
// ./client/app/common/filters/filters.js